import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPhilipshueComponent } from './simple-icons-philipshue.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPhilipshueComponent ],
    exports:      [ SimpleIconsPhilipshueComponent ],
    bootstrap:    []
})
export class SimpleIconsPhilipshueModule {}
